import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PaginationResponse } from '@/state/root.models'
import { initialState } from './initial-state'

import {
  getCountriesListExtraReducer,
  getPlayersExtraReducer,
  getPlayerExtraReducer,
  getPlayerBalanceExtraReducer,
  updatePlayerExtraReducer,
  updateAccountStatusExtraReducer,
  updateKYCStatusExtraReducer,
  getRGExclusionExtraReducer,
  setPlayerBalanceExtraReducer,
} from '../thunks'
import { PlayerCardModels } from '../'

export const playerCardSlice = createSlice({
  name: 'playerCard',
  initialState,
  reducers: {
    setPlayerCardPaginationAction(
      state,
      action: PayloadAction<PaginationResponse>,
    ) {
      state.paginationSearch = action.payload
    },
    resetPlayerCardAction(state) {
      state.playerCard = initialState.playerCard
    },
    setRGCoolOffFiltersAction(
      state,
      action: PayloadAction<PlayerCardModels.ResponsibleGamingFiltersType>,
    ) {
      state.filtersCoolOff = action.payload
    },
    setRGExclusionFiltersAction(
      state,
      action: PayloadAction<PlayerCardModels.ResponsibleGamingFiltersType>,
    ) {
      state.filtersCoolOff = action.payload
    },
  },
  extraReducers: (builder) => {
    getCountriesListExtraReducer(builder)
    getPlayersExtraReducer(builder)
    getPlayerExtraReducer(builder)
    getPlayerBalanceExtraReducer(builder)
    updatePlayerExtraReducer(builder)
    updateAccountStatusExtraReducer(builder)
    updateKYCStatusExtraReducer(builder)
    getRGExclusionExtraReducer(builder)
    setPlayerBalanceExtraReducer(builder)
  },
})

export const PlayerCardActions = playerCardSlice.actions
